import { BaseApolloResponse } from '@customer-portal/shared';

export interface CheckUserExistsResult {
  email: string;
  isUserExist: boolean;
}

export interface CheckUserExistsResponse
  extends BaseApolloResponse<CheckUserExistsResult> {
  data: CheckUserExistsResult;
}
